import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getInventorySettings,
  setInventorySettings,
} from "data/server_apis/inventoryService";

const initialState = {
  data: {
    id: 1,
    stock_level: "location",
    enable_filling_person_stock: false,
  },
  loading: {},
  error: {},
  success: {},
};

export const getStockSettingsThunk = createAsyncThunk(
  "stockSettings/get",
  async (_, { rejectWithValue }) => {
    try {
      return (await getInventorySettings()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const setStockSettingsThunk = createAsyncThunk(
  "stockSettings/set",
  async (data, { rejectWithValue }) => {
    try {
      return (await setInventorySettings(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const inventorySettingsSlice = createSlice({
  name: "InventorySettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStockSettingsThunk.pending, (state, action) => {
        state.loading = { get: true };
        state.success = {};
        state.error = {};
      })
      .addCase(getStockSettingsThunk.fulfilled, (state, action) => {
        state.success = { get: true };
        state.loading = {};
        state.error = {};
        state.data = action.payload;
      });

    builder
      .addCase(setStockSettingsThunk.pending, (state, action) => {
        state.loading = { post: true };
        state.success = {};
        state.error = {};
      })
      .addCase(setStockSettingsThunk.fulfilled, (state, action) => {
        state.success = { post: true };
        state.loading = {};
        state.error = {};
        state.data = action.payload;
      })
      .addCase(setStockSettingsThunk.rejected, (state, action) => {
        state.error = { post: action.payload?.message };
      });
  },
});

export const {} = inventorySettingsSlice.actions;

export default inventorySettingsSlice.reducer;
